// global
import React from 'react';
import PropTypes from 'prop-types';

function ComponentWrapper({ children, dependency, condition }) {
  const show = (dependency, condition) => {
    if (dependency === null && condition) {
      return true;
    }
    if (dependency !== null && condition) {
      return true;
    }
    return false;
  };

  return <>{show(dependency, condition) && children}</>;
}

ComponentWrapper.defaultProps = {
  condition: true,
  dependency: null
};

ComponentWrapper.propTypes = {
  children: PropTypes.node,
  dependency: PropTypes.number,
  condition: PropTypes.bool
};

export default ComponentWrapper;
